<template>
  <v-row no-gutters
         class="pa-0 font-weight-regular">
    <v-col cols="12">
      <v-select
          :value="paddock"
          @input="updatePaddock"
          :items="paddocks"
          item-text="name"
          return-object
          hide-selected
          dense
          outlined
          hide-details>
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
  import {mapState} from 'vuex'
    export default {
      name: 'ChangeRanch',
      data () {
        return {
          paddockSlt: null,
        }
      },
      computed: {
        ...mapState({
          paddocks: state => state.paddocks,
          paddock: state => state.paddock
        }),
      },
      methods: {
        updatePaddock(e) {
          this.$store.commit('setPaddock', e);
        }
      },
    };
</script>

<style scoped>
</style>
